import { render, staticRenderFns } from "./ParamsShareNew.vue?vue&type=template&id=26f6e0e3"
import script from "./ParamsShareNew.vue?vue&type=script&lang=js"
export * from "./ParamsShareNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports